import { Constants } from "@models/constants"
import { Term } from "@models/term";

export class ConstantsStore {
  constructor(
    public constants: Constants = null,
    public upcomingTerm: Term = null
  ) {}
}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/store/constants.ts